<section class="text-center grid">
  <div class="p-offset-0 col-12 md:col-6 md:col-offset-3">
    <p-card>
      <img src="/assets/images/Aline_logo-12.png" alt="Aline" width="200" />

      <p-message></p-message>

      <section class="mt-2">
        @if (loginEvent === 'login') {
          <div>
            @if (!retry && !eraError) {
              <div>
                {{ 'era-login.redirect' | translate }}
              </div>
              <div class="mt-2">
                {{ 'era-login.redirect-help' | translate }}
                <a (click)="eraLogin()" class="pointer">{{
                  'era-login.redirect-help-link' | translate
                }}</a
                >.
              </div>
            }
          </div>
        }
        @if (loginEvent === 'confirm') {
          <section>
            @if (!eraError) {
              <div>
                {{ 'era-login.login-success' | translate }}
              </div>
              <div class="mt-2">
                {{ 'era-login.redirect-help' | translate }}
                <a [routerLink]="['/']">
                  {{ 'era-login.redirect-help-link' | translate }} </a
                >.
              </div>
            }
          </section>
        }
      </section>
      <section class="mt-2">
        @if (retry) {
          <button pButton [type]="'button'" (click)="eraLogin()" class="mr-4">
            {{ 'era-login.btn-try-again' | translate }}
          </button>
        }

        <button
          pButton
          [type]="'button'"
          [routerLink]="['/logout']"
          class="p-button-secondary"
        >
          {{ 'common.button.cancel' | translate }}
        </button>
      </section>
    </p-card>
  </div>
</section>
